export default __webpack_public_path__ + "static/media/profile-banner2.090a3570.png";